export default class Auction {
  constructor(data) {
    this.id = parseInt(data.auctionId, 10) || 0;
    this.appointmentId = parseInt(data.appointmentId, 10) || 0;
    this.carId = parseInt(data.carId, 10) || 0;
    this.brand = data.brand || '';
    this.model = data.model || '';
    this.year = data.year || 0;
    this.carPhoto = data.carPhoto || null;
    this.timeStart = parseInt(data.timeStart, 10) || 0;
    this.timeFinish = parseInt(data.timeFinish, 10) || 0;
    this.bestBidPrice = parseInt(data.bestBidPrice, 10) || 0;
    this.fullPrice = parseInt(data.fullPrice, 10) || 0;
    this.startPrice = parseInt(data.startPrice, 10) || 0;
    this.bidsCount = parseInt(data.bidsCount, 10) || 0;
    this.sellingPriceMeter = data.sellingPriceMeter;

    this.status = data.status || '';

    this.secondsLeft = -1;
    this.secondsToStart = -1;

    this.isBidding = false;
    this.isNew = false;
    this.isOld = false;

    this.appointmentTodayDelta = null;
    this.loading = false;
  }

  getSortValue() {
    if (this.isActive()) {
      return `0${this.timeStart}`;
    }

    if (this.isFinished()) {
      return `1${this.timeFinish}`;
    }

    return `2${this.timeStart || (this.appointmentTime + (60 * 60))}`;
  }

  isToday() {
    return this.appointmentTodayDelta === 0 || this.isActive();
  }

  isTomorrow() {
    return this.appointmentTodayDelta === 1 && !this.isActive();
  }

  isFuture() {
    return this.appointmentTodayDelta > 1 && !this.isActive();
  }

  isActive() {
    return this.status === 'active';
  }

  isBooked() {
    return this.status === 'ready';
  }

  isPreparation() {
    return ['filled', 'inspection', 'expected'].indexOf(this.status) >= 0;
  }

  isFinished() {
    return this.secondsLeft <= 0;
  }

  getChance() {
    const chance = this.sellingPrice <= this.startPrice
      ? 1
      : (this.bestBidPrice - this.startPrice) / (this.sellingPrice - this.startPrice);

    return chance > 0 ? chance : 0;
  }

  update(params) {
    Object.keys(params).forEach((key) => {
      if (typeof this[key] !== 'undefined') {
        this[key] = params[key] !== null ? params[key] : '';
      }
    });
  }

  show() {
    const auction = this;

    auction.isNew = true;

    setTimeout(() => {
      auction.isNew = false;
    }, 500);
  }

  hide(next = () => { }) {
    const auction = this;

    auction.isOld = true;

    setTimeout(() => {
      next();
      auction.isOld = false;
    }, 500);
  }

  startBidding(callback) {
    const auction = this;

    auction.isBidding = true;

    setTimeout(() => {
      if (typeof callback === 'function') {
        callback();
      }

      auction.isBidding = false;
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/store/entity/auction.js